import React, { Component } from 'react';
import classNames from 'classnames';
import './styles.scss';

import { connect } from 'react-redux';

interface ImageTextProps {
  imgSrc?: string;
  imgAlt?: string;
  vertical?: boolean;
  large?: boolean;
  small?: boolean;
  type?: string;
  children?: any;
}

class ImageText extends Component<ImageTextProps> {
  componentDidMount() {}

  render() {
    const { imgSrc, imgAlt, vertical, large, small, type } = this.props;
    const imageTextClasses = classNames({
      'image-text': true,
      'image-text--vertical': vertical,
    });
    const imageTextImgClasses = classNames({
      'image-text__img': true,
      'image-text__img--large': large,
      'image-text__img--small': small,
      'image-text__img--rule': type === 'rules',
    });
    const imageTextTxtClasses = classNames({
      'image-text__txt': true,
      'image-text__txt--large-padding-left': large,
      'image-text__txt--rule': type === 'rules',
    });
    return (
      <div className={imageTextClasses}>
        <div className={imageTextImgClasses}>
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className={imageTextTxtClasses}>{this.props.children}</div>
      </div>
    );
  }
}

export default connect()(ImageText);
